/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
import { updatePageDetails, changePage } from '@insticator/insticator-ui'; // iui-state
import { getEmailData, downloadEmailData } from 'state/actions/emailCollectionState/selected_embed_email_data';
import { clearSelectedEmailState } from 'state/actions/emailCollectionState/selected_embed_email_status';
// component
import EmbedEmails from 'pages/dashboard/embeds/emails/embedemails'


/* ========== ~~~~~~~~~~ EMBED ANALYTICS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({emailCollectionState}) => ({
    selectedEmbed: emailCollectionState.selectedEmbedEmailStatus.selectedEmbed,
    loading: emailCollectionState.selectedEmbedEmailStatus.loading,
    downloading: emailCollectionState.selectedEmbedEmailStatus.downloading,
    embedEmails: emailCollectionState.selectedEmbedEmailData.embedEmails,
    isDataReceived: emailCollectionState.selectedEmbedEmailData.isDataReceived,
    currentPage: emailCollectionState.selectedEmbedEmailData.currentPage,
    totalRows: emailCollectionState.selectedEmbedEmailData.totalRows,
    totalPages: emailCollectionState.selectedEmbedEmailData.totalPages
});

// map actions
const mapDispatchToProps = dispatch => ({
    getEmailData: (embedUUID, page, startDate, endDate) => dispatch(getEmailData(embedUUID, page, startDate, endDate)),
    downloadEmailData: (embedUUID, page, startDate, endDate) => dispatch(downloadEmailData(embedUUID, page, startDate, endDate)),
    clearSelectedEmailState: () => dispatch(clearSelectedEmailState()),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(EmbedEmails));
